import React from "react"
import PropTypes from "prop-types"
// Styles
import {
   Container,
   Wrapper,
   Overlay,
   Image,
   Text,
   Title,
} from "./PageSectionSolo.styles"

const PageSectionSolo = ({ image, title, text }) => {
   return (
      <Container>
         <Image src={image} />
         <Overlay />
         <Wrapper>
            <Title
               dangerouslySetInnerHTML={{
                  __html: title?.replace(/\n/g, "<br />"),
               }}
            />
            <Text
               dangerouslySetInnerHTML={{
                  __html: text?.replace(/\n/g, "<br />"),
               }}
            />
         </Wrapper>
      </Container>
   )
}

PageSectionSolo.propTypes = {
   image: PropTypes.string,
   title: PropTypes.string,
   text: PropTypes.string,
}

export default PageSectionSolo
